module.exports = __webpack_public_path__ + "static/media/OrdersIcon.aab8ca37.svg";